export const locale = {
    lang: 'pl',
    data: {
        'New': 'Nowa',
        'Edit': 'Edycja',
        'Country': 'Kraj',
        'Vat name': 'Nazwa stawki VAT',
        'Vat value': 'Wartość stawki VAT',
        'Actions': 'Akcje',
        'Vat name is required!': 'Nazwa stawki VAT jest wymagana',
        'Vat value is required!': 'Wartość stawki VAT jest wymagana',
        'Country is required!': 'Kraj jest wymagany',
        'Save': 'Zapisz',
        'Vat rate data': 'Dane stawki VAT',
    }
};
